import { render, staticRenderFns } from "./veStuHealthReport.vue?vue&type=template&id=35795f1f&scoped=true"
import script from "./veStuHealthReport.vue?vue&type=script&lang=js"
export * from "./veStuHealthReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35795f1f",
  null
  
)

export default component.exports